import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    productsOrder: [],
    defaultProductsOrder: [],
    productsVisibility: {},
};

export const productsInfoStore = createSlice({
    name: "productsInfoStore",
    initialState,
    reducers: {
        loadProductOrderState: (state, action) => {
            state.productsOrder = action.payload;
        },
        loadDefaultProductOrderState: (state, action) => {
            state.defaultProductsOrder = action.payload;
        },
        loadProductsVisibility: (state, action) => {
            state.productsVisibility = action.payload;
        },
        resetProductsInfoStore: () => initialState,
    },
});
export const { loadProductOrderState, loadDefaultProductOrderState, loadProductsVisibility, resetProductsInfoStore } = productsInfoStore.actions;

export default productsInfoStore.reducer;
